module.exports = __webpack_public_path__ + "09_mole.89fe14da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/09_mole.png
// module id = m1aZ
// module chunks = 0